// Globals
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Pagination, Table } from '@/ui';
import { StyledWrapper } from '../Styled';
import { StyledPagination } from './PropertiesTableStyles';

// Models
import { IProperty } from '@/models/property.model';
import { IPagination } from '@/models/pagination.model';

// Helpers
import { getEntityId } from '@/utils';
import { getPropertiesTableColumns } from '../../helpers';

type TPropertyListProps = {
  data: IProperty[];
  isLoading: boolean;
  header?: ComponentType;
  onPageChange?: (pagination: { cursor?: string; limit?: number }) => void;
  pagination?: IPagination;
  onRowClick?: (id: string) => void;
  isSold?: boolean;
};

const PropertiesTable = ({
  isLoading,
  data,
  header,
  onPageChange,
  pagination,
  onRowClick,
  isSold = false,
}: TPropertyListProps) => {
  const { t } = useTranslation(['property', 'common']);

  return (
    <StyledWrapper>
      <Table
        columns={getPropertiesTableColumns({ t, isSold })}
        onRow={({ PK }) => ({
          onClick: () => onRowClick?.(getEntityId(PK)),
        })}
        rowKey="PK"
        dataSource={data}
        scroll={{ x: 'max-content' }}
        loading={isLoading}
        components={{
          header: {
            wrapper: header,
          },
        }}
      />
      <StyledPagination>
        <Pagination onChange={onPageChange} cursor={pagination} />
      </StyledPagination>
    </StyledWrapper>
  );
};

export default PropertiesTable;
